const Icons = {
    Info: (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M7.00583 10.4167H7M7 5.16667V8.66667M7 12.75C4.1005 12.75 1.75 10.3995 1.75 7.5C1.75 4.6005 4.1005 2.25 7 2.25C9.89949 2.25 12.25 4.6005 12.25 7.5C12.25 10.3995 9.89949 12.75 7 12.75Z" stroke="#DB9E21" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default Icons;